import script from "./onGetCustomer.vue?vue&type=script&setup=true&lang=js"
export * from "./onGetCustomer.vue?vue&type=script&setup=true&lang=js"

import "./onGetCustomer.vue?vue&type=style&index=0&id=4801a014&lang=css"

const __exports__ = script;

export default __exports__